
/* injects from baggage-loader */

'use strict';

import bg from '_images/packs/bg.png';
import { Puzzle, NumeralsI18n } from '../../../index.const';

import { findIndex } from 'lodash';

export default class DialogTrophiesController {
    constructor($log, $sce, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$sce = $sce;
        this.Trophies = Trophies;
        this.Puzzle = Puzzle;
        this.bg = bg;
    }

    $onInit() {
        this.collecteds = this.Trophies.collectThrophies(this.resolve.totalParts);
        this.totalCollectedI18n = NumeralsI18n.female[ this.collecteds.length ];
    }

    ok(){
      this.modalInstance.close(true);
    }

    cancel(){
      this.modalInstance.dismiss('cancel');
    }

    renderPuzzlePart(part) {
        let trophies = this.Trophies.getThrophies()
        let index =  findIndex(trophies, { name: part.name })
        return this.Puzzle[index];
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/trophies/trophies.controller.js